const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: 'https://ridhimittal.com',
  title: 'RM.',
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'Ridhi Mittal',
  role: '',
  description:
    "I’m a Senior Software Developer at Jeppesen Foreflight, where I work with airlines to streamline scheduling workflows and improve efficiency across global training operations. With a background in software development, computer science, and neuroscience I love solving complex problems that have a real impact.",
  resume: '',
  social: {
    linkedin: 'https://linkedin.com/in/ridhimittal',
    // github: 'https://github.com/ridhimittal3',
  },
  email: 'mittalridhi3@gmail.com',
}

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    name: 'Senior Software Developer @ Jeppesen Foreflight',
    description:
      'Led delivery of a major product feature that accelerated value to airline operations by 2+ months, impacting over 17,000 flight crew members.',
    stack: ['Python', 'XML', 'SQL'],
    livePreview: 'https://www.jeppesenforeflight.com/',
  },
  // {
  //   name: 'Professional Scrum Product Owner',
  //   description:
  //     'Successfuly completed the Scrum.org PSPO I course, which covers the Scrum framework and how to apply it to maximize the value delivered with a product.',
  //   stack: ['Jira', 'Visio', 'Excel'],
  //   livePreview: 'https://www.credly.com/badges/9965daa7-daa2-4f1e-b627-3371deb3b7d7/public_url',
  // },
  // {
  //   name: 'Software Developer @ RI-MUHC',
  //   description:
  //     'Deployed a prototype healthcare ML algorithm at one of the largest health networks in North America.',
  //   stack: ['AngularJS', 'Django', 'SQL'],
  //   livePreview: 'https://rimuhc.ca/',
  // },
  {
    name: 'Software Developer @ Opal',
    description:
      'Enhanced functionality of Opal, a web application designed to provide patients with real-time access to their medical data.',
    stack: ['Python', 'Django', 'AngularJS'],
    livePreview: 'https://opalmedapps.com/',
  },
  {
    name: 'ML Lab Fellow @ Mila',
    description:
      'Designed and implemented a ML prototype for a virtual meeting tool that detects audio-based interruptions for the AI4Good Lab.',
    stack: ['TensorFlow', 'AWS', 'sci-kit learn', 'pandas'],
    sourceCode: 'https://github.com/AI4GoodProject/speechRecForMeeting',
    livePreview: 'https://www.canva.com/design/DAFD_hi3t0Q/raxVAqYuJYYD3ZWIafcBbQ/edit?utm_content=DAFD_hi3t0Q&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton',
  },
]

const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  {name: 'ceramics', image: '/images/ceramics.png', caption: 'Handmade pieces made by me!'},
  {name: 'knitting'}, // Add photo of amateur scarf
  {name: 'becoming a chess master'}, // Add my chess.com link/QR code
  {name: 'napping'},
  {name: 'health tech'},
  {name: 'exploring new countries'}, // Add some travel photos
]

const contact = {
  // email is optional - if left empty Contact section won't show up
  // email: 'mittalridhi3@gmail.com',
}

export { header, about, projects, skills, contact } 
